module.exports = __webpack_public_path__ + "img/facebook-icon.415d67bd.svg";